import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { CodeItemService } from '../../common/services/codeitem.service';
import { ProgrammingUtilsService } from './../../common/services/utils.service';
import { ProgrammingEventService } from './../../common/services/event.service';


@Component({
  selector: 'prg-select-category',
  templateUrl: './select-category.component.html',
  styleUrls: ['./select-category.component.css']
})
export class SelectCategoryComponent implements OnInit {
  categories: Observable<Array<any>>;
  origin: string;

  constructor(
    private store: Store<any>,
    private router: Router,
    private route: ActivatedRoute,
    private utils: ProgrammingUtilsService,
    private eventService: ProgrammingEventService,
    private codeitemService: CodeItemService
  ) {
    this.categories = this.store.select(s => s.sharedProgramming.categories);
  }

  ngOnInit() {
    this.route.parent.params.take(1).subscribe(params => {
      if (params) {
        this.origin = params['origin'];
        console.log('navigated to select-category for ', this.origin);
      }
    });
  }

  categorySelected(value: string) {
    switch (this.origin) {
      case 'event':
        this.eventService.selectCategory(value);
        break;

      case 'command':
      case 'condition':
      case 'loop':
        this.codeitemService.selectCategory(value);
        break;

      default:
        console.error('invalid route context, no origin provided');
    }

    this.router.navigate([value, 'device'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/select-category/select-category.component.ts